import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { UtilitiesService } from '../../../store/services/utilities.servive';

@Pipe({ name: 'timezone' })
export class TimezonePipe implements PipeTransform {
  constructor(private readonly utilService: UtilitiesService) {
  }

  transform(
    value: string | Date | moment.Moment,
    dateFormat: string,
    timezone?: string,
  ): any {
    if (!value) {
      return '';
    }
    let mObject = null;
    if (!timezone || !this.hasTimeInFormat(dateFormat)) {
      try {
        mObject = moment(value);
        if (!mObject._isValid) {
          return value;
        }
      } catch (e) {
        return '';
      }
      return mObject.format(dateFormat);
    }

    try {
      mObject = moment.utc(value);
      if (!mObject._isValid) {
        return value;
      }
    } catch (e) {
      return '';
    }

    return mObject
      .tz(this.utilService.getMomentTimezone(timezone))
      .format(dateFormat);
  }

  private hasTimeInFormat(format: string): boolean {
    return format.indexOf(' ') !== -1;
  }
}
